var _style, _polygon, _rect, _path, _polygon2, _polygon3, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLikaLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 209.1",
    style: {
      enableBackground: "new 0 0 500 209.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "116.5,55.1 83.9,55.1 83.9,155.4 169.4,155.4 169.4,130.3 116.5,130.3 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 190.9,
    y: 55.1,
    className: "st0",
    width: 32.7,
    height: 100.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M444.8,55.1h-22.5l-56,100.3h31.8l9.3-18.2h49.5l8.6,18.2h31.8L444.8,55.1z M447.5,114.1h-29.9l15.5-30.5 L447.5,114.1z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "316.1,105.1 357.4,54.4 317.7,54.4 279.3,101.4 279.3,55.2 246.9,55.2 246.9,154.9 279.3,154.9  279.3,108.7 317.7,155.7 357.4,155.7 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "105.2,4.2 42,81.9 2,81.9 65.2,4.2 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M482.6,75.4c-5.5,0-10-4.5-10-10s4.5-10,10-10s10,4.5,10,10S488.1,75.4,482.6,75.4 M482.6,56.9 c-4.6,0-8.3,3.8-8.3,8.4s3.7,8.4,8.3,8.4c4.6,0,8.3-3.8,8.3-8.4S487.2,56.9,482.6,56.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M485.4,70l-1.9-2.8c-0.1,0-0.3,0-0.5,0h-2.4V70h-1.7v-9.3h4.1c2.6,0,4.1,1.2,4.1,3.2c0,1.5-0.8,2.5-2.1,3 l2.3,3.1H485.4z M483.1,65.7c1.6,0,2.5-0.6,2.5-1.9c0-1.2-0.9-1.8-2.5-1.8h-2.4v3.7H483.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLikaLight);
export default __webpack_public_path__ + "static/media/logo_lika_light.d72528d1dad0da449fd2650f2141befc.svg";
export { ForwardRef as ReactComponent };